module.exports = __webpack_public_path__ + "static/media/icon-other.3b71e362.png";